import React from "react";
import IntlMessages from "@util/IntlMessages";
import "./style.less";
import { Spin } from "../../BP2Components";

const TimelineItem = ({ styleName, color, listData, value, children }) => {
   const { dateAttribute, titleAttribute, descriptionAttribute } = value;

   const date =
      listData[dateAttribute] != null
         ? listData[dateAttribute].value != null
            ? listData[dateAttribute].value
            : listData[dateAttribute]
         : "";
   const title =
      listData[titleAttribute] != null
         ? listData[titleAttribute].value != null
            ? listData[titleAttribute].value
            : listData[titleAttribute]
         : "";

   const description =
      listData[descriptionAttribute] != null
         ? listData[descriptionAttribute].value != null
            ? listData[descriptionAttribute].value
            : listData[descriptionAttribute]
         : "";

   return (
      <>
         {listData !== undefined ? (
            <div className={`gx-timeline-item gx-timeline-time-item ${styleName}`}>
               <div className="gx-timeline-time">{date}</div>
               <div className={`gx-timeline-badge gx-bg-${color}`}>{children}</div>
               <div className="gx-timeline-panel">
                  <span style={{ fontSize: "x-large" }} className={`gx-text-${color}`}>
                     {title !== undefined ? title : ""}
                  </span>
                  <p>
                     {isNaN(description) ? description : parseInt(description)}{" "}
                     {<IntlMessages id="timeline.hopps" />}
                  </p>
               </div>
            </div>
         ) : (
            <Spin />
         )}
      </>
   );
};
export default TimelineItem;
